(ns teamoesterreich.user-mode.prevent.answer-option-ro
  (:require [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.user-mode.prevent.evaluate :as evaluate]
            [teamoesterreich.util.log :as log]))





(defn new-answer-obj [ao-path answerOptionId answer-option a-obj]
  (merge {:active          false
          :type            (:type answer-option)
          :__answer-option (str ao-path answerOptionId)
          :timestamp       (js/Date.)
          :created         (js/Date.)
          :points          0}
         a-obj))

(defn answer-option-radios
  [answerOptionId answer-option answer-options question-response-cs & [answered-cb]]
  (let [options (map (fn [_ref] (.-id _ref)) (:option-references answer-option))
        answeredOptionId (reduce (fn [c v]
                                   ;(log/out "dgb " (clj->js (deref (r/cursor question-response-cs [:answers v :answer_radio_button]))))
                                   (if (deref (r/cursor question-response-cs [:answers v :answer_radio_button])) v c))
                                 options)
        answeredOptionValue (get-in answer-options [answeredOptionId :text])]
    [:div
     [mui/radio-group {:name          (:radio-group-name answer-option)
                       :valueSelected answeredOptionValue}
      (for [ref_ (:option-references answer-option)]
        (let [radio-option (get answer-options (.-id ref_))
              ]
          ^{:key (str "answerOption-" radio-option)} (mui/radio {:iconStyle {:fill "grey"}
                                                                 :disabled  true
                                                                 :style     {;:border-bottom "1px solid #999"
                                                                             :marginBottom "10px"}
                                                                 :label     (str " " (:text radio-option))
                                                                 :value     (str "" (:text radio-option))

                                                                 }))
        )
      ]
     [:br]]
    ))


(defn answer-option-checkbox_
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (or (:answer_checkbox answer-option-resp) false)]
    (log/out (str "update option `" (:text answer-option) "` checked " answer-option-resp " " answer))
    [:div
     (mui/checkbox {:iconStyle {:fill "black"}
                    :label     (str (if ((keyword "text$dynamic") answer-option)
                                      (evaluate/calculate-and-set ((keyword "text$dynamic") answer-option))
                                      (:text answer-option)))
                    :checked   answer
                    :on-check  (fn [e v]
                                 (log/out (str "option `" (:text answer-option) "` checked " v))
                                 (answered-cb answerOptionId {:answer_checkbox v
                                                              :points          (if v (:points answer-option) 0)
                                                              :timestamp       (js/Date.)}))
                    })
     [:br]]
    ))

(defn answer-option-checkbox
  [answerOptionId answer-option answer-option-response-cs]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_checkbox answer-option-resp)]
    (log/out (str "update option `" (:text answer-option) "` checked " answer-option-resp " " answer))
    [mui/list-item
     {:style {:textAlign "center"}}
     [mui/list-item-text
      (:text answer-option)
      [:br]
      [:div {:style {:textAlign "center"}}
       [mui/button {:style    {:marginBottom     "20px" :margin-top "10px" :margin-right "10px" :border "1px solid grey" :border-radius "15px"
                               :background-color (if (true? answer) "grey" "white")
                               :color            (if (true? answer) "white" "grey")
                               }
                    :disabled true
                    } "Ja"]
       [mui/button {:style    {:marginBottom     "20px" :margin-top "10px" :margin-right "10px" :border "1px solid grey" :border-radius "15px"
                               :background-color (if (false? answer) "grey" "white")
                               :color            (if (false? answer) "white" "grey")
                               }
                    :disabled true
                    } "Nein"]
       [mui/button {:style    {:marginBottom     "20px" :margin-top "10px" :border "1px solid grey" :border-radius "15px"
                               :background-color (if (nil? answer) "grey" "white")
                               :color            (if (nil? answer) "white" "grey")
                               }
                    :disabled true
                    } "?"]
       ]
      ]]
    ))

(defn answer-option-text
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_text answer-option-resp)]
    [mui/list-item
     {:style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline true
        ;:label (:hint answer-option)
        :disabled  true
        :value     (str "" answer)}
       ]
      ]
     ]
    ))

(defn answer-option-numeric
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_numeric answer-option-resp)]
    [mui/list-item
     {:style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline true
        ;:label (:hint answer-option)
        :disabled  true
        :value     (str "" answer)}
       ]
      ]
     ]
    ))


(defn answer-option-decimal
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_decimal answer-option-resp)]
    [mui/list-item
     {:style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline true
        ;:label (:hint answer-option)
        :disabled  true
        :value     (str "" answer)}
       ]
      ]
     ]
    ))


(defn answer-option
  [answerOptionId answer-option answer-options question-response-cs answer-option-response-cs]
  (log/out "answer-option ->" (clj->js answer-option) (clj->js @answer-option-response-cs))

  ^{:key (str "answerOption-" answerOptionId)} (case (:type answer-option)
                                                 "radio_button" nil
                                                 "image" nil
                                                 "radio_group" ""
                                                 "checkbox" (answer-option-checkbox answerOptionId answer-option answer-option-response-cs)
                                                 "text" (answer-option-text answerOptionId answer-option answer-option-response-cs)
                                                 "numeric" (answer-option-numeric answerOptionId answer-option answer-option-response-cs)
                                                 "decimal" (answer-option-decimal answerOptionId answer-option answer-option-response-cs)
                                                 [mui/list-item {:style {:color "red"}} (str (:type answer-option) "  " (:text answer-option))])
  )



(defn answer-options [question-cs question-response-cs]
  (let [answer-options (:answer-options @question-cs)]
    (log/out "answer-options-app ->" (clj->js @question-cs) (clj->js @question-response-cs))
    [mui/list {:style {:margin "0 40px 0 40px" :textAlign "center"}}
     (for [[answerOptionId ao] (sort-by (fn [[uuid e]] (:index e)) answer-options)]
       (let [answer-option-response-cs (r/cursor question-response-cs [:answers answerOptionId])]
         (answer-option answerOptionId ao answer-options question-response-cs answer-option-response-cs)))]))














